import { LoadingButton } from '@mui/lab'
import { Box, Button, Card, CardActions, CardContent, CardHeader, Divider, InputAdornment, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useUpdateMerchantSubscriptionMutation } from 'src/_api/planApi'
import { TextFieldNumber } from 'src/_modules/common'
import MerchantPlanEditsByAdminDialog from '../components/MerchantPlanEditsByAdminDialog'

export default function TaskExtraPriceAndSmsCard({
    merchantId,
    subscriptionInfo
}) {
    const { t } = useTranslation()

    const [planPayload, setPlanPayload] = useState({
        extraTaskPrice: 0,
        SMSPrice: 0
    })

    const handleChange = (event) => {
        const { name, value } = event.target
        setPlanPayload((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        if (subscriptionInfo?.plan) {
            setPlanPayload({
                extraTaskPrice: subscriptionInfo?.plan?.extraTaskPrice,
                SMSPrice: subscriptionInfo?.plan?.SMSPrice
            })
        }
    }, [subscriptionInfo])

    const [
        updateMerchantSubscription,
        {
            isLoading,
            isSuccess,
            error,
            reset
        }] = useUpdateMerchantSubscriptionMutation()

    const updateMerchantSubscriptionHandler = async () => {
        try {
            // Convert to numbers and validate
            const extraTaskPrice = Number(planPayload?.extraTaskPrice);
            const SMSPrice = Number(planPayload?.SMSPrice);

            // Check if valid numbers
            if (isNaN(extraTaskPrice) || isNaN(SMSPrice)) {
                return
            }

            // Pass validated numbers to the mutation
            await updateMerchantSubscription({
                merchantId,
                payload: { extraTaskPrice, SMSPrice }
            }).unwrap()

            setTimeout(() => {
                reset()
            }, 3000)

        } catch (error) {
            console.log("Error updating subscription:", error);
        }
    }

    const [open, setOpen] = useState(false)

    return (
        <Card>
            <CardHeader title={t("Extra Task Price & SMS Price")} />
            <Divider />
            <CardContent>
                <TextFieldNumber
                    size="small"
                    margin="normal"
                    label={t("Extra task price")}
                    name="extraTaskPrice"
                    value={planPayload?.extraTaskPrice}
                    onChange={handleChange}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="start">{t("Halalas")}</InputAdornment>,
                    }}
                />
                <TextFieldNumber
                    size="small"
                    margin="normal"
                    label={t("SMS Price")}
                    name="SMSPrice"
                    value={planPayload?.SMSPrice}
                    onChange={handleChange}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="start">{t("Halalas")}</InputAdornment>,
                    }}
                />
            </CardContent>
            <Divider />
            <CardActions>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <MerchantPlanEditsByAdminDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    merchantId={merchantId}
                    />
                <Button
                    variant="outlined"
                    sx={{ textTransform: "none" }}
                    onClick={() => setOpen(true)}
                >
                    {t("Edits Logs")}
                </Button>
                <LoadingButton
                    variant="contained"
                    loading={isLoading}
                    onClick={updateMerchantSubscriptionHandler}
                    sx={{ textTransform: "none" }}
                >
                    {t("Update")}
                </LoadingButton>
            </CardActions>
        </Card>
    )
}
